import { render } from "./CadastroClienteFeatures.vue?vue&type=template&id=0bd966a4"
import script from "./CadastroClienteFeatures.vue?vue&type=script&lang=ts"
export * from "./CadastroClienteFeatures.vue?vue&type=script&lang=ts"
script.render = render

export default script